import React from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
  Link as MuiLink,
} from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

export default function HomeNavbar() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const token = sessionStorage.getItem("authToken");

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" color="success" variant="">
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Typography variant="h6" component="div">
            <MuiLink
              component={RouterLink}
              to="/"
              color="inherit"
              underline="none"
            >
              <img
                src="assets/logos/RitaWhite-2023Logo.png"
                alt="logo"
                style={{ width: "150px", height: "50px" }}
              />
            </MuiLink>
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <MuiLink
              component={RouterLink}
              to="/"
              color="inherit"
              underline="none"
              sx={{ marginRight: 4 }}
            >
              {t("navigation.list.home")}
            </MuiLink>
            {token ? (
              <>
                <HashLink
                  component={RouterLink}
                  smooth
                  to="/#platform-info"
                  style={{
                    marginRight: "40px",
                    color: "inherit",
                    textDecoration: "none",
                  }}
                >
                  {t("navigation.list.platforminia")}
                </HashLink>
                <MuiLink
                  component={RouterLink}
                  to="/dashboard"
                  color="inherit"
                  underline="none"
                  sx={{ marginRight: 4 }}
                >
                  Go to Dashboard
                </MuiLink>
                <MuiLink
                  component={RouterLink}
                  to="/contact"
                  color="inherit"
                  underline="none"
                  sx={{ marginRight: 4 }}
                >
                  {t("navigation.list.contact")}
                </MuiLink>
              </>
            ) : (
              <>
                <MuiLink
                  component={RouterLink}
                  to="/mission"
                  color="inherit"
                  underline="none"
                  sx={{ marginRight: 4 }}
                >
                  {t("navigation.list.consortiumRita")}
                </MuiLink>
                <MuiLink
                  component={RouterLink}
                  to="/newsletters-subscribe"
                  color="inherit"
                  underline="none"
                  sx={{ marginRight: 4 }}
                >
                  {t("navigation.list.newsletter")}
                </MuiLink>
                <MuiLink
                  component={RouterLink}
                  to="/contact"
                  color="inherit"
                  underline="none"
                  sx={{ marginRight: 4 }}
                >
                  {t("navigation.list.contact")}
                </MuiLink>
              </>
            )}
          </Box>

          <Box display="flex" alignItems="center">
            <LanguageSwitcher />
            {!token && (
              <>
                <Button
                  color="inherit"
                  onClick={() => {
                    navigate("/signin");
                  }}
                  sx={{ marginRight: 2, marginLeft: 5 }}
                >
                  {t("navigation.list.signIn")}
                </Button>

                <Button
                  variant="contained"
                  sx={{
                    background: "white",
                    color: "green",
                    "&:hover": {
                      color: "white",
                      background: "green",
                    },
                  }}
                  color="success"
                  size="large"
                  onClick={() => {
                    navigate("/signup");
                  }}
                >
                  {t("navigation.list.signUp")}
                </Button>
              </>
            )}
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
